'use strict';

import {generationAjaxCall} from '../genbar/generationBar';

$('.js-first-generation-form').on('submit', function (event) {
  event.preventDefault();
  var $thisGenForm = $(this);
  var params = $thisGenForm.serialize();

  generationAjaxCall(params, $thisGenForm);
});
